<template>
  <div class="cbg-account-restore">
    <p class="cbg-account-restore__title">Change password</p>
    <form class="cbg-auth-form" @submit.prevent="changePassword">
      <div class="cbg-account-restore__password">
        <div class="cbg-account-restore__password-old">
          <PasswordInput ref="oldInput" v-model="oldPassword" class-name="cbg-account-restore__input" input-name="Old password" :is-wrong="isPasswordWrong"/>
          <button class="cbg-account-restore__password-btn" type="button" @click="()=>logOut(true)">Forgot password?</button>
        </div>
        <PasswordInput ref="passwordInput" v-model="password" class-name="cbg-account-restore__input" input-name="New password" :is-new="true" :email-string="emailString" :is-same="isNewPasswordSame"/>
        <PasswordInput ref="confirmInput" v-model="confirmPassword" class-name="cbg-account-restore__input" input-name="Confirm password" :confirm-password="password"/>
      </div>
      <div class="cbg-account-restore__buttons">
        <button class="cbg-account-restore__buttons-item" :disabled="isDisabled || isLoading" type="submit">
          <span>Change password</span>
          <span v-if="isLoading" class="spinner"></span>
        </button>
        <button class="cbg-account-restore__buttons-item cbg-account-restore__buttons-item_bordered" type="button" @click="cancelChange">Cancel</button>
      </div>
    </form>
  </div>
</template>

<script>
import {ContextUpdateSymbol, ContextStateSymbol} from '../../global/Context.vue';
import PasswordInput from "@/components/elements/PasswordInput.vue";
import {formValidation} from "@/mixins/formValidation";
import {requestValidation} from "@/mixins/requestValidation";
import {sendRequests} from "@/mixins/sendRequests";
import {userData} from "@/mixins/userData";
export default {
  name: 'AccountPassword',
  components: {
    PasswordInput,
  },
  mixins: [requestValidation, formValidation, sendRequests, userData],
  data() {
    return {
      oldPassword: '',
      password: '',
      confirmPassword: '',
    };
  },
  computed: {
    emailString() {
      return this.context ? this.context.userData?.email?.split("@")[0]: '';
    }
  },
  methods: {
    changePassword() {
      this.isValidAll();

      if (!this.isDisabled) {
        this.changePasswordRequest(this.oldPassword, this.password);
      }
    },

    cancelChange() {
      this.updateContext && this.updateContext('step', 1);
    },

  },
}
</script>